function hasText(value, minLength = 1) {
  return String(value || "").trim().length >= minLength;
}

function hasMedia(entity = {}) {
  if (hasText(entity.image) || hasText(entity.posterUrl) || hasText(entity.avatarUrl)) {
    return true;
  }

  if (Array.isArray(entity.mediaUrls) && entity.mediaUrls.length > 0) return true;
  return false;
}

function isPublicCapsule(entity = {}) {
  const capsuleType = String(entity.capsuleType || "").trim().toLowerCase();
  return capsuleType === "public" || capsuleType === "sponsored";
}

export function isEntityIndexable(routeKey, entity = {}) {
  switch (routeKey) {
    case "home":
    case "watch":
      return true;
    case "profile":
      return hasText(entity.handle || entity.publicHandle, 2) && hasText(entity.displayName || entity.userName, 2);
    case "business":
      return hasText(entity.displayName || entity.companyName || entity.name, 2) && (hasText(entity.description, 24) || hasMedia(entity));
    case "series":
      return hasText(entity.title || entity.name, 2) && (hasText(entity.description, 40) || hasMedia(entity));
    case "video":
      return hasText(entity.title || entity.name, 2) && (hasText(entity.description, 30) || hasMedia(entity));
    case "raffle":
      return hasText(entity.title || entity.name, 2) && hasText(entity.description, 20);
    case "capsule":
      return (
        isPublicCapsule(entity) &&
        (hasText(entity.title || entity.headline || entity.message, 12) || hasMedia(entity))
      );
    default:
      return false;
  }
}

export function getRobotsContent({ routeKey, eligibleRoute, entityIndexable, forceNoindex = false }) {
  if (forceNoindex) return "noindex,nofollow";
  if (!eligibleRoute) return "noindex,nofollow";
  if (!entityIndexable) return "noindex,follow";

  if (routeKey === "capsule") {
    return "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";
  }

  return "index,follow";
}

